import React from "react";
import { useTranslation } from "react-i18next";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";

import "./LoggingInPage.scss";
import ImageGoogleSmallButtonIcon from "../../../images/google.svg";
import DefaultOnboardingStatusPage from "../../ReusablePages/DefaultOnboardingStatusPage/DefaultOnboardingStatusPage";
import { getStoredAuthProvider } from "../../../utils/storage";
import FacebookLogo from "../../../images/facebook-logo.svg";
import LoadingDots from "../../../components/LoadingDots/LoadingDots";
import GameControllerIcon2 from "../../../components/icons/GameControllerIcon2";
import useVerifyAuth from "../../../hooks/useVerifyAuth";

function LoggingInPage() {
  useVerifyAuth();
  const { t } = useTranslation("common", { keyPrefix: "onboarding" });
  const titleText = (
    <span className="d-flex align-items-baseline">
      {t("continuing_with_provider", {
        provider:
          getStoredAuthProvider() === OAuthProvider.FACEBOOK
            ? "Facebook"
            : getStoredAuthProvider() === OAuthProvider.GOOGLE
              ? "Google"
              : "",
      })}{" "}
      <LoadingDots dotStyles={{ background: "white" }} />
    </span>
  );

  return (
    <div>
      <DefaultOnboardingStatusPage
        titleText={titleText}
        secondaryText={t("please_wait_while_we_create_your_account")}
        primaryImage={
          getStoredAuthProvider() === OAuthProvider.FACEBOOK
            ? FacebookLogo
            : ImageGoogleSmallButtonIcon
        }
        secondaryIcon={<GameControllerIcon2 className="spinning-controller" />}
        stayOnPage
      />
    </div>
  );
}

export default LoggingInPage;
